import { render } from "./IconBalance.vue?vue&type=template&id=3a3b5322"
import script from "./IconBalance.vue?vue&type=script&lang=js"
export * from "./IconBalance.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__